export class NotificationPaginationHelperModel {
  public PageSize: number = 20;
  public PageNumber: number = 1;
  public LanguageId: number;
  [param: string]: string | number;
}
